import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.gallery-slider__splide' ).length ) {
        $( '.gallery-slider__splide' ).each( function( index, element ) {
          const slider = new Splide( element, {
            type: 'loop',
            perPage: 1,
            focus: 'center',
            gap: '-28px',
            padding: '28%',
            arrows: true,
            pagination: false,
            speed: 600,
            breakpoints: {
              768: {
                padding: '8%',
                gap: '1rem',
              },
            },
          } );

          slider.on( 'mounted', function() {
            const activeSlide = slider.Components.Slides.getAt( slider.index );
            if ( activeSlide ) {
              activeSlide.slide.classList.add( 'is-center' );
            }
          } );

          slider.on( 'move', function( newIndex ) {
            slider.Components.Slides.forEach( function( slide ) {
              slide.slide.classList.remove( 'is-center' );
            } );
            const newSlide = slider.Components.Slides.getAt( newIndex );
            if ( newSlide ) {
              newSlide.slide.classList.add( 'is-center' );
            }
          } );

          slider.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'gallery-slider', COMPONENT );
} )( app );
